export default __webpack_public_path__ + "static/media/news49.9359fb05.jpg";